var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFileUploadOrange = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE5F10",
    fillRule: "evenodd",
    d: "M8 2c1.72 0 3.236 1.107 3.783 2.697 1.626.22 2.883 1.618 2.883 3.303 0 .814-.296 1.597-.833 2.206-.132.149-.315.225-.5.225-.157 0-.314-.054-.441-.166-.276-.245-.302-.666-.058-.942.322-.364.499-.835.499-1.323 0-1.103-.897-2-2-2h-.067c-.317 0-.59-.224-.653-.535C10.363 4.23 9.265 3.333 8 3.333s-2.364.897-2.613 2.132c-.063.31-.337.535-.654.535h-.067c-1.102 0-2 .897-2 2 0 .488.178.959.5 1.323.244.276.218.697-.058.941-.276.245-.698.217-.941-.058-.538-.609-.834-1.392-.834-2.206 0-1.685 1.257-3.083 2.883-3.303C4.764 3.107 6.28 2 8 2zm-.464 5.52c.263-.25.678-.249.935.009l2 2c.26.26.26.682 0 .942-.13.13-.3.196-.471.196-.17 0-.342-.066-.472-.196l-.862-.862v3.724c0 .369-.298.667-.666.667-.368 0-.667-.298-.667-.667V9.571l-.87.84c-.265.256-.687.248-.943-.017-.256-.265-.248-.687.016-.943l2-1.931z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFileUploadOrange, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/file-upload__orange.b123bfa7.svg";
export { ForwardRef as ReactComponent };